// @flow

import { startRequest, finishRequest } from "@store/utils";
import type {
  AITeamSettings,
  ClientServiceAbsenceManagement,
} from "@modules/client/reducer/service/types";

export const setLoading = (state: Object) => () => {
  return {
    ...state,
    service: {
      ...startRequest(state.service),
    },
  };
};

export const onGetClientAITeamSettingsSuccess = (state: Object) => ({
  payload,
}: {
  payload: AITeamSettings,
}) => {
  return {
    ...state,
    error: null,
    service: {
      ...finishRequest(state.service),
      aiTeamSettings: payload,
    },
  };
};

export const onGetClientAITeamSettingsError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    service: {
      ...finishRequest(state.service),
    },
  };
};

export const onGetClientServiceSuccess = (state: Object) => ({
  payload,
}: {
  payload: ClientServiceAbsenceManagement,
}) => {
  return {
    ...state,
    error: null,
    service: {
      ...finishRequest(state.service),
      service: payload,
    },
  };
};

export const onSetClientServiceSchema = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    service: {
      ...finishRequest(state.service),
      schema: payload,
    },
  };
};

export const onDismissAddNewService = (state: Object) => () => {
  return {
    ...state,
    service: {
      ...state.service,
      modals: {
        ...state.service.modals,
        addService: {
          ...state.service.modals.addService,
          visible: false,
        },
      },
    },
  };
};

export const onAddNewServiceError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    service: {
      ...finishRequest(state.service),
    },
  };
};

export const onGetClientServiceError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    service: {
      ...finishRequest(state.service),
    },
  };
};
